<template>
    <div class="content">
        <TopBar barStyle="background-color: #fff; border-bottom: #d3dbde solid 0.02rem;">
            <span class="title" slot="title">会员福利</span>
        </TopBar>
        <div class="welfare-des">
            <div class="part-top">
                <div class="pic-box hvc">
                    <img :src="privilege.outBlackIcon" :alt="privilege.name">
                </div>
                <div class="text-box">{{privilege.name}}</div>
            </div>
            <div class="part-detail wrap">
                <ul>
                    <li>
                        <div class="item-title vc"><i class="icon icon-line"></i>福利内容</div>
                        <div class="item-detail" v-html="privilege.content"></div>
                    </li>
                    <li>
                        <div class="item-title vc"><i class="icon icon-line"></i>使用说明</div>
                        <div class="item-detail" v-html="privilege.useDirections"></div>
                    </li>
                    <li>
                        <div class="item-title vc"><i class="icon icon-line"></i>福利规则</div>
                        <div class="item-detail" v-html="privilege.rule"></div>
                    </li>
                </ul>
            </div>
            <div class="btn-wrap hvc" v-if="privilege.immediatelyUseFlag && checkType(privilege.type, userLevel)">
                <a class="btn-item btn-use hvc" :href="privilege.immediatelyUseLink">立即使用</a>
            </div>
        </div>
    </div>
</template>

<script>
    import TopBar from '@/components/top-bar/'
    import axios from '@/libs/api.request'
    export default {
        name: 'welfareDes',
        components: {
            TopBar
        },
        data: () => {
            return {
                userLevel: 0,
                privilege: {}
            }
        },
        mounted () {
            this.getUserLevelPrivilege()
                .then(res => {
                    this.userLevel = this.getLevel(res.customerInfo.userLevel)
                })
            this.getPrivilegeById(this.$route.query.Id)
                .then(res => {
                    window.console.log(res)
                    this.privilege = res
                })
        },
        methods: {
            getLevel (userLevelText) {
                switch (userLevelText) {
                    case '初级会员':
                        return 1
                    case '高级会员':
                        return 2
                    case '精英会员':
                        return 3
                    case '卓越会员':
                        return 4
                }
            },
            checkType (type, userLevel) {
                if (type === 0 || type === 1 && userLevel === 1 || type === 2 && userLevel !== 1) return true
            },
            getUserLevelPrivilege () {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/CustomerInfo/ApiGetUserLevelPrivilege',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            loyaltyId: this.$store.state.user.loyaltyId
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            },
            getPrivilegeById (Id) {
                return new Promise(resolve => {
                    axios.request({
                        url: '/api/Privilege/ApiGetPrivlegeById',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${this.$store.state.user.token}`
                        },
                        data: {
                            Id
                        }
                    })
                        .then(res => {
                            let data = res.data
                            if (data.errCode === 0) {
                                resolve(data.data)
                            } else if (data.errCode === 1000) {
                                window.console.log('失败')
                            } else {
                                window.console.log('系统错误')
                            }
                        })
                        .catch(err => {
                            window.console.log(err)
                        })
                })
            }
        }
    }
</script>

<style lang="less" scoped>
.welfare-des{
    min-height: 100vh;
    padding-top: 1.40rem;
    background-color: #f5f6f8;
    .part-top{
        padding-bottom: 0.46rem;
        .pic-box{
            width: 1.50rem;
            height: 1.50rem;
            margin: 0 auto;
            background-color: #fac400;
            border-radius: 100%;
            img{
                width: 1.20rem;
            }
        }
        .text-box{
            padding-top: 0.12rem;
            font-size: 0.30rem;
            line-height: 0.48rem;
            text-align: center;
        }
    }
    .part-detail{
        padding-top: 0.02rem;
        padding-bottom: 1.30rem;
        ul{
            li{
                margin-bottom: 0.40rem;
                .item-title{
                    padding-bottom: 0.34rem;
                    font-size: 0.30rem;
                    .icon-line{
                        width: 0.04rem;
                        height: 0.30rem;
                        margin-right: 0.10rem;
                        background-color: #fbc500;
                        border-radius: 0.02rem;
                    }
                }
                .item-detail{
                    padding-left: 0.14rem;
                    color: #747d80;
                    line-height: 0.32rem;
                    word-break: break-all;
                    word-wrap: break-word;
                }
            }
        }
    }
    .btn-wrap{
        position: fixed;
        left: 0;
        bottom: 0;
        width: 100%;
        z-index: 99;
        height: 1.26rem;
        border-top: #d4dbde solid 0.02rem;
        background-color: #fff;
        .btn-use{
            display: flex;
            display: -webkit-flex;
            width: 6.92rem;
            height: 0.95rem;
            background-color: #fbc500;
            border-radius: 0.05rem;
            font-size: 0.30rem;
        }
    }
}
</style>
